import React from 'react'
import { makeStyles, Box, Typography } from '@material-ui/core'
import { clsx } from 'clsx'
import { OutlinedButton } from '../components/buttons/Buttons'
import { useHistory } from "react-router-dom";
import charlotteSins from '../images/charlotteSins.png'
import lillyBell from '../images/LillyBell.png'
import charlieForde from '../images/CharlieForde.png'

const VerifiedBadge = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M9.999 1.547L7.319 0L5.833 2.575H2.716V5.752L0 7.32L1.547 10L0 12.6795L2.716 14.248V17.2005H5.7035L7.319 20L9.999 18.453L12.679 20L14.295 17.2H17.376V14.195L20 12.6795L18.4525 10L20 7.3205L17.376 5.8055V2.5755H14.1665L12.679 0L9.999 1.547ZM13.7065 7.1595L14.8335 8.303L9.1185 14.053L5.701 10.588L6.823 9.459L9.1165 11.7495L13.7065 7.1595Z" fill="#FE5A97" />
    </svg>
)

const CURATED_CREATORS = [
    {
        image: charlotteSins,
        name: "Charlotte Sins",
        badge: "Fine Art Glamour",
        description: "Fine art glamour & behind-the-scenes. New sets every Friday, custom requests open.",
        posts: "312",
        subscribers: "18.4k"
    },
    {
        image: lillyBell,
        name: "Lilly Bell",
        badge: "Sensual",
        description: "Exclusive photos, intimate moments, and premium content curated for dedicated subscribers.",
        posts: "573",
        subscribers: "28.4k"
    },
    {
        image: charlieForde,
        name: "Charlie Forde",
        badge: "Travel",
        description: "Go beyond the highlights with authentic moments, exclusive collections, and updates released every week.",
        posts: "865",
        subscribers: "30.1k"
    }
]

const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: "52px",
        fontWeight: 400,
        lineHeight: "100%",
        textAlign: "left",
        [theme.breakpoints.down('sm')]: {
            fontSize: '36px',
        },
    },
    sectionText: {
        fontSize: '18px',
        color: '#ffffff',
        lineHeight: "27px",
        fontWeight: 200,
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            lineHeight: '24px',
        }
    },
    featuresSection: {
        maxWidth: 1314,
        margin: "0 auto",
        padding: "60px 24px",
        textAlign: "center",
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            padding: "36px 21px",
        },
    },
    brMobileHide: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        }
    },
    featuresHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 44,
        flexWrap: 'wrap',
        gap: 20,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
        },
    },
    featuresTitle: {
        maxWidth: "50%",
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            textAlign: 'center',
        },
    },
    featuresDescription: {
        width: "50%",
        maxWidth: "531px",
        textAlign: "left",
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            textAlign: 'center',
        },
    },
    curatedSection: {
        padding: "60px 21px",
        [theme.breakpoints.down('sm')]: {
            padding: "36px 21px",
        },
    },
    curatedDescription: {
        margin: "auto 0"
    },
    collectionGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 20,
        marginBottom: theme.spacing(6),
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            overflowX: 'auto',
            scrollSnapType: 'x mandatory',
            paddingBottom: theme.spacing(2),
            marginBottom: theme.spacing(3),
            '&::-webkit-scrollbar': {
                display: 'none',
            },
            '-ms-overflow-style': 'none',
            'scrollbar-width': 'none',
        },
    },
    collectionCard: {
        backgroundColor: "#1B1B1B",
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '12px',
        height: '527px',
        [theme.breakpoints.down('sm')]: {
            height: '400px',
            minWidth: '280px',
            scrollSnapAlign: 'start',
            flexShrink: 0,
        },
        '&:hover $collectionImage': {
            transform: 'scale(1.15)',
        },
    },
    collectionImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: 'transform 0.4s ease',
    },
    cardOverlay: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '24px 20px 20px',
        background: 'linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.6) 50%, transparent 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    cardName: {
        fontFamily: "'Roboto', sans-serif",
        fontSize: '18px',
        fontWeight: 600,
        color: '#FF4D8C',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        marginBottom: '10px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            lineHeight: "24px",
        },
    },
    cardBadge: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 400,
        fontSize: '14px',
        color: '#D7A7B9',
        border: '1px solid #D7A7B9',
        borderRadius: '20px',
        padding: '3px 10px',
        height: '28px',
        marginBottom: '14px',
        textTransform: 'none',
    },
    cardDesc: {
        fontFamily: "'Roboto', sans-serif",
        fontSize: '16px',
        fontWeight: 200,
        color: 'rgba(255, 255, 255)',
        lineHeight: "24px",
        height: '48px',          /* 2 lines × 24px — keeps all cards aligned */
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        marginBottom: '20px',
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            lineHeight: "21px",
            height: '42px',      /* 2 lines × 21px */
        },
    },
    cardStats: {
        display: 'flex',
        gap: '40px',
        width: '100%'
    },
    statValue: {
        fontFamily: "'Roboto', sans-serif",
        fontSize: '20px',
        fontWeight: 600,
        color: '#FFFFFF',
        lineHeight: '100%'
    },
    statLabel: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 200,
        fontSize: '16px',
        color: '#747474',
        marginTop: '6px'
    },
    viewCollectionButton: {
        fontSize: "16px",
        borderRadius: "6px",
        fontWeight: 600,
        [theme.breakpoints.down('sm')]: {
            width: '100% !important',
        }
    },
}))

export const CuratedExcellenceSection: React.FC = () => {
    const classes = useStyles()
    const history = useHistory();
    return (
        <Box className={clsx(classes.featuresSection, classes.curatedSection)}>
            <Box className={classes.featuresHeader}>
                <Typography variant="h2" className={clsx(classes.sectionTitle, classes.featuresTitle)}>
                    Curated <br className={classes.brMobileHide} />
                    Excellence.
                </Typography>
                <Typography className={clsx(classes.sectionText, classes.featuresDescription, classes.curatedDescription)}>
                    We hand-select every creator on the platform. From high-fashion boudoir to luxury jet-setters, discover independent visionaries who are setting the new standard for premium content.
                </Typography>
            </Box>
            <Box className={classes.collectionGrid}>
                {CURATED_CREATORS.map((creator, index) => (
                    <Box key={index} className={classes.collectionCard}>
                        <img
                            src={creator.image}
                            alt={creator.name}
                            className={classes.collectionImage}
                        />
                        <Box className={classes.cardOverlay}>
                            <Typography className={classes.cardName}>
                                {creator.name} <VerifiedBadge />
                            </Typography>
                            <span className={classes.cardBadge}>{creator.badge}</span>
                            <Typography className={classes.cardDesc} title={creator.description}>
                                {creator.description}
                            </Typography>
                            <Box className={classes.cardStats}>
                                <Box>
                                    <Typography className={classes.statValue}>{creator.posts}</Typography>
                                    <Typography className={classes.statLabel}>Posts</Typography>
                                </Box>
                                <Box>
                                    <Typography className={classes.statValue}>{creator.subscribers}</Typography>
                                    <Typography className={classes.statLabel}>Subscribers</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
            <OutlinedButton text="View the Genesis Collection" styles={classes.viewCollectionButton} onClick={() => history.push('/genesis-collection')} />
        </Box>
    )
}
